import { useAppDispatch } from "../../store/configureStore";
import type { FC } from "react";
import { Margin } from "@kivra/react-components";
import { routes } from "../../utils/routes";
import { ErrorMessage } from "../errors/ErrorMessage";
import { KivraHeaderRouter } from "../header/KivraHeaderRouter";
import { useCopy } from "../../utils/globalContext";
import { ButtonContainer } from "../layouts/ButtonContainer";
import { LinkButton } from "../atoms/LinkButton";
import { setTermsAccepted } from "../../store/auth";

export const LoginLanding: FC = () => {
  const copy = useCopy();
  const dispatch = useAppDispatch();

  // Reset Terms and Conditions when loading the front page
  dispatch(setTermsAccepted(false));

  return (
    <div style={{ minWidth: "250px" }}>
      <KivraHeaderRouter />
      <ErrorMessage />
      <Margin bottom={46} />
      <ButtonContainer>
        <LinkButton
          type="button"
          size="medium"
          variant="primary"
          to={routes.LOGIN}
        >
          {copy("btn_login_password")}
        </LinkButton>
        <LinkButton
          type="button"
          size="medium"
          variant="secondary"
          to={routes.SIGNUP_V2}
        >
          {copy("btn_register")}
        </LinkButton>
      </ButtonContainer>
    </div>
  );
};
